import React from 'react';

import $routes from 'js/core_pre_webpack/routes';
import { ContentSection } from 'js/design_system/ContentSection';
import { GridColumn } from 'js/design_system/grid/Grid';
import { AshbyJob } from './ashby_types';
import { ButtonLink } from 'js/design_system/link/ButtonLink';

const EMPLOYMENT_TYPE_MAP: Record<string, string> = {
  FullTime: 'Full-time',
};

const AshbyRole = ({ job }: { job: AshbyJob }) => (
  <li className="role">
    <a target="_blank" href={job.jobUrl}>
      <div className="role-grid">
        <GridColumn className="role-team" sm={3} md={2} lg={2}>
          {job.team}
        </GridColumn>
        <GridColumn className="role-commitment" sm={3} md={4} lg={6}>
          {EMPLOYMENT_TYPE_MAP[job.employmentType] || job.employmentType}
        </GridColumn>
        <GridColumn className="role-description" sm={6} md={6} lg={8}>
          {job.title}
        </GridColumn>
        <GridColumn className="role-location" sm={6} md={6} lg={8}>
          {job.location}
          {/* This is missing from the ashby API (it should say "remote" or "hybrid"),
           *  add back if they ever fix the API */}
          {/* - {capitalize(job.workplaceType)} */}
        </GridColumn>
      </div>
    </a>
  </li>
);

const AshbyJobsList: React.FC<{
  jobsByDepartment: [string, AshbyJob[]][];
  showAllRolesCta: boolean;
}> = ({ jobsByDepartment, showAllRolesCta }) => {
  return (
    <>
      {jobsByDepartment.map(([department, jobs]) => (
        <ContentSection key={department} heading={department} grid subgrid>
          <ul className="roles-list">
            {jobs.map((job: AshbyJob) => (
              <AshbyRole key={job.id} job={job} />
            ))}
          </ul>
          {showAllRolesCta && (
            <div className="open-roles-cta-button">
              <ButtonLink
                href={$routes.openings_url()}
                iconRight="arrow_forward"
              >
                View all open roles
              </ButtonLink>
            </div>
          )}
        </ContentSection>
      ))}
    </>
  );
};

export default AshbyJobsList;
